'use client';

import { MouseEventHandler, SetStateAction, useEffect, useRef, useState } from 'react';

import { CodeInsert } from '@/icons';
import Button from '../Button';
import { PromptExamples } from '@/types/terminal';
import { HoverableIcon } from './HoverableIcon';
import { SupportedActionsDropDown } from './SupportedActionsDropDown';
import Link from 'next/link';
import { twMerge } from 'tailwind-merge';

export const Input = ({
  actions,
  debouncedSendMessage,
  setPrompt,
  handleKeyDown,
  prompt,
  placeholder = 'Message',
  className,
  inputClassName,
}: {
  actions?: PromptExamples;
  debouncedSendMessage?: MouseEventHandler<HTMLButtonElement> | undefined;
  setPrompt: (value: SetStateAction<string>) => void;
  handleKeyDown: (event: React.KeyboardEvent<HTMLInputElement>) => void;
  prompt: string;
  placeholder?: string;
  className?: string;
  inputClassName?: string;
}) => {
  const [activeButton, setActiveButton] = useState<string | null>(null);

  const inputRef = useRef<HTMLInputElement>(null);

  useEffect(() => {
    if (!prompt) return;

    if (inputRef.current) {
      inputRef.current.focus();
    }
  }, [prompt]);

  return (
    <div className="flex items-center gap-2">
      <div className={twMerge('w-full flex items-center gap-2 bg-grey-1000 rounded-lg', className)}>
        <div className="flex gap-2 p-[10px]">
          {!!actions?.length && (
            <SupportedActionsDropDown
              actions={actions}
              activeButton={activeButton}
              setPrompt={setPrompt}
              setActiveButton={setActiveButton}
            />
          )}
          {/* <Link href="https://docs.mode.network/" rel="noopener noreferrer" target="_blank" className="">
            <HoverableIcon
              icon={CodeInsert}
              label="Prompt guide"
              isActive={activeButton === 'guide'}
              onMouseEnter={() => setActiveButton('guide')}
              onMouseLeave={() => setActiveButton(null)}
            />
          </Link> */}
        </div>

        <input
          ref={inputRef}
          type="text"
          placeholder={placeholder}
          value={prompt}
          onChange={(e) => setPrompt(e.target.value)}
          onKeyDown={handleKeyDown}
          className={twMerge(
            'flex-1 bg-transparent font-sans text-white placeholder:text-grey-350 outline-none',
            inputClassName
          )}
        />
      </div>
      {!!debouncedSendMessage && (
        <Button
          size="md"
          onClick={debouncedSendMessage}
          className="font-medium bg-yellow-500 text-black hover:bg-yellow-500/40 transition-colors rounded capitalize"
        >
          Ask
        </Button>
      )}
    </div>
  );
};
